
import { WeatherCondition } from '@/types/weather';
import { Variants } from 'framer-motion';

export const getAnimationVariants = (condition: WeatherCondition, animated: boolean): Variants => {
  // Base animation variants that work for most conditions
  const baseVariants: Variants = {
    initial: { 
      scale: 1,
      y: 0
    },
    animate: { 
      y: [0, -10, 0],
      transition: { 
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    hover: {
      scale: 1.1,
      transition: { duration: 0.2 }
    }
  };

  // Specific animations for different weather conditions
  switch (condition) {
    case 'wind':
      return {
        ...baseVariants,
        animate: {
          rotate: [0, 5, 0, -5, 0],
          transition: {
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }
        }
      };
    case 'thunderstorm':
      return {
        ...baseVariants,
        animate: {
          scale: [1, 1.05, 1],
          filter: ["brightness(1)", "brightness(1.3)", "brightness(1)"],
          transition: {
            duration: 0.8,
            repeat: Infinity,
            ease: "easeInOut"
          }
        }
      };
    case 'snow':
      return {
        ...baseVariants,
        animate: {
          rotate: [0, 10, 0, -10, 0],
          y: [0, -5, 0],
          transition: {
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }
        }
      };
    case 'alert':
      return {
        ...baseVariants,
        animate: {
          scale: [1, 1.1, 1],
          transition: {
            duration: 0.5,
            repeat: Infinity,
            ease: "easeInOut"
          }
        }
      };
    default:
      return baseVariants;
  }
};
